/*!
 * jQuery Validation Plugin extension for Diligentia OV
 * 
 * MUST be loaded after jQuery validate
 *
 * Version: 0.1
 */
(function(factory) {
	/*
	 * if ( typeof define === "function" && define.amd ) { define( ["jquery",
	 * "./jquery.validate"], factory ); } else if (typeof module === "object" &&
	 * module.exports) { module.exports = factory( require( "jquery" ) ); } else {
	 */
	factory(jQuery);
	/*
	 * }
	 */
}(function(jQuery) {
	
	// keep a reference to previous defaults
	var jQueryValidatorDefaults = jQuery.validator.defaults;
	var jQueryValidatorPrototype = jQuery.validator.prototype;
	var timers = {};
	
	// Custom validations go in file jquery-validate-ov-validations-0.1.js
	
	/**
	 * Calls a function from a target object.
	 * 
	 * Used to call previous handlers overwritten
	 */
	var execFunction = function(handler, target, $this, $args, after) {
		if (handler in target && typeof target[handler] === "function") {
			if (typeof $args === "undefined") {
				args = [];
			} else if (!($args instanceof Array)) {
				$args = [$args];
			}
			
			var result = undefined;
			
			try {
				result = target[handler].apply($this, $args);
			} catch(e) {
				typeof window.console === "object" 
					&& console.error("execFunction: Handler '" + handler + "' error", e);
			}
			
			if (typeof(after) === "function") {
				try {
					after(handler, result);
				} catch(e) {
					typeof window.console === "object"
						&& console.error("execFunction: Callback 'after' error", e);
				}
			}
			
			return result;
		}
	}
	
	/**
	 * Calls a function from a target object after a delay.
	 * 
	 * Used to call previous handlers overwritten.
	 */
	var execFunctionAsync = function(handler, target, $this, $args, delay, after) {
		delay = typeof delay === "number" ? delay : 100;
		
		if (delay > 0 && delay < 50) {
			delay = 50;
		} else if (delay < 0) {
			delay = 0;
		}
		
		if (delay === 0) {
			execFunction(handler, target, $this, $args, after);
		} else {
			setTimeout(function(){
				execFunction(handler, target, $this, $args, after);
			}, delay);
		}
	};
	
	var execAsync = function(name, timeout, callback) {
		if (typeof timers[name] !== "undefined" && timers[name] !== null) {
			clearTimeout(timers[name]);
			timers[name] = null;
		}
		
		timers[name] = setTimeout(callback, 20);
		return timers[name];
	}
	
	var ovDefaults = {
		/**
		 * Handler called after an element have been validated
		 */
		afterElementValidated: function(element, valid) {
			
		},
		/**
		 * onpaste wait timeout milliseconds before checking the value
		 * onpaste event is fired before the pasted content is set and thus a wait is required.
		 * If set to false or 0 disables the timeout 
		 */
		onPasteWaitTimeout: 100,
		onpaste: function( element, event ) {
			var $this = this;
			// var pastedData = e.originalEvent.clipboardData.getData('text');

			// Must use a timeout to wait enough for the input to be filled
			setTimeout(function(){
				if ( element.name in $this.submitted 
						|| element.name in $this.invalid 
						|| !$this.optional( element ) ) {

					$this.element( element );
				}
			}, this.settings.onPasteWaitTimeout || 0);
		},
		oninput: function(element, event) {
			if ( element.name in this.submitted 
					|| element.name in this.invalid 
					|| !this.optional( element ) ) {
				
				this.element( element );
			}
		},
		onfocusin: function( element, event ) {
			execFunction("onfocusin", jQueryValidatorDefaults, this, [element, event]);
		},
		onfocusout: function( element, event ) {
			execFunction("onfocusout", jQueryValidatorDefaults, this, [element, event]);
		},
		onkeyup: function( element, event ) {
			if ( event.which === 8 && this.elementValue( element ) === "") {
				this.element( element );
			} else {
				execFunction("onkeyup", jQueryValidatorDefaults, this, [element, event]);
			}
		},
		onclick: function( element, event ) {
			var jElem = jQuery(element);
			if (jElem.is('[type="radio"]') || jElem.is('[type="checkbox"]')) {
				// Force checkbox and radio validation on click, not after submit
				this.element(element);
			} else {
				execFunction("onclick", jQueryValidatorDefaults, this, [element, event]);
			}
		}
	};
	
	var ovPrototype = {
		// Whether the form was already checked at least once or not
		_firstCheckDone: false,
		init: function() {
			execFunction("init", jQueryValidatorPrototype, this);
			
			var currentForm = this.currentForm;
			
			var eventDelegate = function(event) {
				var isContentEditable = typeof jQuery( this ).attr( "contenteditable" ) !== "undefined" 
					&& jQuery( this ).attr( "contenteditable" ) !== "false";
				
				// Set form expando on contenteditable
				if ( !this.form && isContentEditable ) {
					this.form = jQuery( this ).closest( "form" )[ 0 ];
					this.name = jQuery( this ).attr( "name" );
				} 
				
				// Ignore the element if it belongs to another form. This will happen mainly
				// when setting the `form` attribute of an input to the id of another form.
				if (typeof currentForm != undefined && currentForm !== this.form ) {
					return;
				}
				
				var validator = jQuery.data( this.form, "validator" ),
					eventType = "on" + event.type.replace( /^validate/, "" ),
					settings = validator.settings;
				
				if ( settings[ eventType ] && !jQuery( this ).is( settings.ignore )) {
					settings[ eventType ].call( validator, this, event );
				}
			};
			
			var elementsSelector = ":text, [type='password'], [type='file'], select, textarea, [type='number'], " + 
			"[type='search'], [type='tel'], [type='url'], [type='email'], [type='datetime'], [type='date'], " +
			"[type='month'], [type='week'], [type='time'], [type='datetime-local'], [type='range'], [type='color'], " +
			"[type='radio'], [type='checkbox'], [contenteditable]";
			
			// Handle both paste and input events
			jQuery( this.currentForm )
				.on( "paste.validate input.validate", elementsSelector, eventDelegate);
		},
		/**
		 * Ensures that all initially visible form elements are properly handled
		 * 
		 * Adds data-ov-* attributes to elements without them and removes them from elements that are hidden but are
		 * returned by elements() call.
		 */
		initElements: function(selector) {
			// Control wether there are already validated values and a checkForm is required
			var mustCheckElements = false;
			
			var targetElements = null;
			
			if (typeof selector === "string") {
				targetElements = jQuery(selector);
			} else {
				targetElements = this.elements();
			}
			
			// Get current elements. Those does not include submit/reset buttons, image input or disabled elements
			// Also excludes configured ignored elements, that by default is just :hidden
			targetElements.each(function(pos, formElem){
				var jElem = jQuery(formElem);
				// Double check those
				var hidden = jElem.is(':disabled') || jElem.is(':hidden')
					|| jElem.is('[type="hidden"]') || jElem.prop('readonly')
					|| jElem.is('[type="submit"]') || jElem.is('[type="reset"]');
				
				// Previous validation state
				var validation = jElem.attr("data-ov-validation");
				
				if (hidden) {
					// Element must not be validated, remove validation attributes
					jElem.removeAttr("data-ov-validation");
				} else if (!validation) {
					// Otherwise if the element does not have the first set a default value for both
					jQuery(formElem).attr("data-ov-validation", "pending");
				} else if (validation === "valid" || validation === "invalid") {
					
					// In case the value is already validated we will force a checkForm at the end
					mustCheckElements = true;
				}
			});
			
			if (mustCheckElements && typeof selector === "string") {
				// Check only selected ones forcing showing errors and using the data attributes that might be set
				for(var index = 0; index < targetElements.length; index++) {
					this.check(targetElements[index], true, true);
				}
			} else if (mustCheckElements) {
				// Check all the form elements as usual
				this.checkForm();
			}
			
			// Always disable this flag to avoid validation issues. If this function is called first without a selector
			// then the rest of form elements must be handled later
			this._firstCheckDone = true;
		},
		/**
		 * Calls afterElementValidated handler and sets data attributes on the validated element with the result of
		 * validation.
		 * @param element Validated DOM node
		 * @param valid Validation result. Non boolean values must be handled gracefully
		 * @param hint String with a key to identify the source of the notification
		 */
		_notifyAfterElementValidated: function(element, valid, hint) {
			
			var validation = "pending";
			
			if (typeof valid === "boolean") {
				validation = valid ? "valid" : "invalid";
			}
			
			// Always update last validation state
			jQuery(element).attr("data-ov-validation", validation);
			
			if (typeof valid === "boolean" && typeof this.settings.afterElementValidated === "function") {
				var $this = this;
				var name = "notify_validated---" + element.name + "::" + (hint || "x");
				
				if (validation !== "invalid") {
					// be sure that this attribute is not present if the field is validation pending or already valid.
					jQuery(element).removeAttr("data-ov-error-key");
				}
				
				if (this.settings.debug && typeof window.console !== "undefined") {
					console.debug(name + " => " + valid);
				}
				
				execAsync(name, 50, function(){
					$this.settings.afterElementValidated(element, valid);
				});
			}
		},
		/**
		 * Intercept the element validation function and add data attributes to each validated element
		 */ 
		element: function(element) {
			var valid = execFunction("element", jQueryValidatorPrototype, this, [element]);
			
			this._notifyAfterElementValidated(element, valid, "element");
			
			return valid;
		},
		/**
		 * Overrides original check and forces showing errors of invalid fields.
		 * 
		 * Calls original check function if no data attributes are present.
		 * 
		 * @param element DOM Element to validate
		 * @param showMessages boolean Flag to show validation messages or not. Defaults to true.
		 * @param checkDataAttributes boolean Flag to force the use of data attributes as the source of validation 
		 * state or not. Data attributes are always set after validation but those are used before and instead
		 * of validation.
		 */
		check: function(element, showMessages, checkDataAttributes) {
			var valid = false;
			var jElem = jQuery(element);
			
			if (jElem.attr("data-ov-validation-ignore") === "true") {
				return true;
			}
			
			var validation = jElem.attr("data-ov-validation");
			// Whether to use the value from data-ov-validation or to ignore it
			var useDataAttributes = (checkDataAttributes || !this._firstCheckDone)
				&& (validation === "valid" || validation === "invalid");
			// Whether to show validation error/success
			var notifyValidationResult = typeof showMessages === "undefined" || showMessages;
			
			if (useDataAttributes) {
				// Set the validation state from pre-defined attribute
				valid = validation === "valid";
			} else {
				// Check element validation. This returns one of: true/false/undefined/string
				valid = execFunction("check", jQueryValidatorPrototype, this, [element]);
				// Alter flag to include check for a boolean validation result
				notifyValidationResult = notifyValidationResult && typeof valid === "boolean";
			}
			
			if (notifyValidationResult) {
				if (valid) {
					// On first check load validity state from data-ov-valid.
					// This sadly does not defines the proper error messages :(
					var rules = $( element ).rules();
					
					if ( this.objectLength( rules ) ) {
						this.successList.push( element );
					}
				}
				
				this.invalid[ element.name ] = valid;
				jQuery( element ).attr( "aria-invalid", !valid);
				// Show errors found if invalid
				this._showPrevalidationErrors(element, valid);
				this._notifyAfterElementValidated(element, valid, "check");
			}
			
			return valid;
		},
		checkForm: function() {
			var valid = execFunction("checkForm", jQueryValidatorPrototype, this, []);
			
			// Always set this flag to true when checkForm is called
			this._firstCheckDone = true;
			
			return valid;
		},
		/**
		 * Handles a prevalidated invalid field.
		 * 
		 * The field must have set the data-ov-validation attribute with value valid/invalid and the error message
		 * must be shown inside the element with class form-error and must have the css class has-error set.
		 */
		_showPrevalidationErrors: function( element, valid ) {
			if (valid !== false) {
				return;
			}

			// If the node specifies an error key get it and remove it to clean up as there is no any other use for
			// it.
			var errorKey = jQuery(element).attr("data-ov-error-key");
			jQuery(element).removeAttr("data-ov-error-key");
			
			// We try to find the error message in the block of error messages. 
			var errorNode = jQuery('.tramite-container.form-errors-container [data-ov-error-key="' + errorKey + '"]');
			
			if (errorNode.length === 0) {
				// If not found we try to find it in the container for field errors
				errorNode = jQuery(element).closest('.ov-form-field')
					.find('.field-error [data-ov-error-key="' + errorKey + '"]');
			}
			
			// The message defaults to empty. This is fine as the field error is highlighted anyway.
			var message = "";
			
			if (errorNode.length > 0) {
				// If found get the text of the first node and trim it. Otherwise let it as empty.
				message = jQuery.trim(errorNode.first().text());
			}

			this.errorList.push( {
				// Use the message found
				message: message,
				element: element,
				// We don't know what caused the validation error
				method: "prevalidated"
			} );

			this.errorMap[ element.name ] = message;
			this.submitted[ element.name ] = message;
		},
		// Return all filled elements
		elementsFilled: function() {
			// Apply double negation over filled and filter out radio inputs not checked
			return this.elements().filter(function(pos, element){
				var jElem = jQuery(element);
				
				if (!jElem.is(":filled")) {
					return false;
				} else if (jElem.prop("tagName").toLowerCase() === "input" && (jElem.attr("type") === "radio"
						|| jElem.attr("type") === "checkbox")) {
					return jElem.is(":checked");
				}
				
				return true;
			});
		},
		/**
		 * Obtains elements and applies a not(':not(<$notFilter>)') to remove unwanted ones.
		 * if the filter already starts with :not it doesn't applies the :not to the selector
		 */ 
		elements: function(notFilter) {
			var result = execFunction("elements", jQueryValidatorPrototype, this);
			
			notFilter = typeof notFilter === "string" ? notFilter.trim() : "";
			
			if (result && notFilter && !notFilter.startsWith(':not')) {
				result = result.not(notFilter);
			} else if (result && notFilter) {
				result = result.not(':not(' + notFilter + ')');
			}
			
			return result;
		},
		optional: function( element, valueOverride ) {
			if (jQuery(element).attr("data-ov-validation-ignore") === "true") {
				return true;
			}
			
			var val = typeof valueOverride !== "undefined" ? valueOverride : this.elementValue( element );
			return !$.validator.methods.required.call( this, val, element ) && "dependency-mismatch";
		},
		/**
		 * Returns all form elements under the current form.
		 * 
		 * This function might return elements with the same name (like radio buttons on the same group) and elements
		 * that have no validation rule set. Default elements() method does not works this way.
		 * 
		 * This function does not returns buttons, image input or elements that are invisible, disabled or marked as
		 * readonly. 
		 */
		all: function() {
			return $( this.currentForm )
				.find( "input, select, textarea" )
				.not( ":submit, :reset, :image, :disabled, :hidden, [readonly]" )
				.not( this.settings.ignore )
				;
		},
		/**
		 * Override focusInvalid to avoid focusing elements with tabindex="-1" or with ov-hidden-input class.
		 */
		focusInvalid: function() {
			if ( this.settings.focusInvalid ) {
				try {
					$( this.findLastActive() || this.errorList.length && this.errorList[ 0 ].element || [] )
					.filter(function(element){
						var jElem = jQuery(element);
						return jElem.is(':visible') 
							// Any value other than "-1" will work
							&& jElem.attr("tabindex") !== "-1"
							// Inputs with this class should not be focused 
							&& !jElem.hasClass('ov-hidden-input');
					})
					.trigger( "focus" )

					// Manually trigger focusin event; without it, focusin handler isn't called, findLastActive won't have anything to find
					.trigger( "focusin" );
				} catch ( e ) {
                    console.error("focusInvalid: ", e)
					// Ignore IE throwing errors when focusing hidden elements
				}
			}
		},
		/**
		 * Checks if a required element does not have a value set
		 */
		isMissing: function(element) {
			return this.check(element, false, false) === false;
		},
		isRequired: function(element) {
			var jElem = element instanceof jQuery ? element : jQuery(element);
			return jElem.is(":required");
		},
		/**
		 * Add a default normalizer
		 */
		normalizer: function(value) {
			return jQuery.trim(value);
		},
		/**
		 * Override this function to properly remove field states on reset
		 */
		resetElements: function( elements ) {
			for (var i = 0; elements[ i ]; i++ ) {
				// Call both hightlight and unhighlight with an empty string
				// in place of the style to add
				if ( this.settings.unhighlight ) {
					this.settings.unhighlight.call( this, elements[ i ],
						this.settings.errorClass, "" );
				} else {
					jQuery(elements[i]).removeClass( this.settings.errorClass );
				}
				
				if ( this.settings.highlight ) {
					this.settings.highlight.call( this, elements[ i ],
							"", this.settings.validClass);
				} else {
					jQuery(elements[i]).removeClass( this.settings.validClass );		
				}
			}
		},
		resetElement: function(element) {
			var jElem = jQuery(element);
			jElem
				.removeData( "previousValue" )
				.removeAttr( "aria-invalid" )
				.attr("data-ov-validation", "pending");

			this.resetElements(jElem);
		}
	};
	
	var validatorExtenderObj = {
		defaults: jQuery.extend({}, jQueryValidatorDefaults, ovDefaults),
		prototype: jQuery.extend({}, jQueryValidatorPrototype, ovPrototype)
	};
	
	jQuery.extend(jQuery.validator, validatorExtenderObj);

	return jQuery;
}));
